import { render } from "./VaultTabs.vue?vue&type=template&id=530ea816&ts=true"
import script from "./VaultTabs.vue?vue&type=script&lang=ts"
export * from "./VaultTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__